var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "2.93,10.45 4.41,8.39 5.96,10.38  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.94,10.97L4.4,7.55l2.56,3.31L1.94,10.97z M4.42,9.22l-0.5,0.7l1.03-0.02L4.42,9.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 11.09,
    cy: 8,
    r: 2.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11.09,10.9c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9S12.69,10.9,11.09,10.9z M11.09,5.35 C9.63,5.35,8.45,6.54,8.45,8s1.19,2.65,2.65,2.65S13.74,9.46,13.74,8S12.55,5.35,11.09,5.35z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "3.02,5.83 4.41,7.77 5.87,5.89  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.4,8.6L2.03,5.31l4.84,0.1L4.4,8.6z M4.01,6.35l0.42,0.58l0.44-0.56L4.01,6.35z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyLight);
export default __webpack_public_path__ + "static/media/EmergencyLight.e843d4a42ae5d15a9d91c30de86a0eba.svg";
export { ForwardRef as ReactComponent };